import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { store } from "@/store";
import { ThemeModeProvider } from "@/context/ThemeContext";
import { NotificationProvider } from "@/context/NotificationContext";
import { AuthInit } from "@/context/AuthContext";
import { router } from "@/routes";

export function App() {
  return (
    <Provider store={store}>
      <ThemeModeProvider>
        <NotificationProvider>
          <AuthInit>
            <RouterProvider router={router} />
          </AuthInit>
        </NotificationProvider>
      </ThemeModeProvider>
    </Provider>
  );
}
